module.exports = __webpack_public_path__ + "img/jiance_cn.97a54466.jpg";